import { useState, useEffect } from 'react';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

let cachedPromise = null;

// A failed or non-ok fetch is not cached — the next useChangelog() call retries — so a
// transient network blip doesn't leave the SPA seeing an empty changelog for the rest of
// the session. Only a successful response is memoized.
// Admin pages that edit this data drop the cache when you navigate away (Layout.jsx), since SPA navigation no longer reloads it.
export function resetChangelogCache() { cachedPromise = null; }

function fetchChangelog() {
  if (!cachedPromise) {
    cachedPromise = fetch(`${API_BASE_URL}/changelog`, { credentials: 'include' })
      .then((r) => {
        if (!r.ok) { cachedPromise = null; return []; }
        return r.json();
      })
      .catch(() => { cachedPromise = null; return []; });
  }
  return cachedPromise;
}

// Fetch-once, process-cached GET /changelog (array of entries, newest first). Shared by
// Layout.jsx's What's New badge check and WhatsNew.jsx's full page view so opening What's
// New from the nav doesn't re-fetch the same data Layout just fetched for the badge.
// ContentAdmin.jsx's CRUD panel deliberately keeps its own fetch (it writes, this doesn't).
export default function useChangelog() {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    fetchChangelog().then((data) => {
      if (!cancelled) {
        setEntries(Array.isArray(data) ? data : []);
        setLoading(false);
      }
    });
    return () => { cancelled = true; };
  }, []);

  return { entries, loading };
}
